import React, { useCallback, useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeIsvFixedFeeThreshold: (value: Nullable<number>) => void;
}

const IsvFixedFeeThresholdField: React.FC<IProps> = ({ changeIsvFixedFeeThreshold }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterIsvFixedFeeThreshold') }], [t]);

	const handleChange = useCallback(
		(value: Nullable<number>) => {
			changeIsvFixedFeeThreshold(value);
		},
		[changeIsvFixedFeeThreshold],
	);

	return (
		<FormInput
			testId="IsvFixedFeeThresholdField"
			name="isvFixedFeeThreshold"
			label="isvFixedFeeThresholdLabel"
			type="number"
			onChangeNumber={handleChange}
			validationRules={validationRules}
			min={0}
			precision={0}
		/>
	);
};

export default React.memo(IsvFixedFeeThresholdField);
